import React from 'react'

import { Modal, Form, Col, Button, Row } from '_zari/core'

import { ZariContext } from '_zari/context'

import { DownloadAxiosFile } from 'utils'

import * as FacturacionHistorialService from 'services/facturacionHistorial.service'

import * as FormGroups from './formGroups'

const DescargarInformeModal = ({ handleClose, show }) => {
  const __zariContext = React.useContext(ZariContext)
  const [fecha, setFecha] = React.useState('')

  const clickDescargar = React.useCallback(() => {
    if (fecha === '') {
      __zariContext.snack('error', 'El campo fecha es requerido')
    } else {
      FacturacionHistorialService.descargarInformeExcel({ fecha })
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers)
          __zariContext.snack('success', 'La descarga del informe se realizo con exito')
          handleClose()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    }
  }, [__zariContext, fecha, handleClose])

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>Descargar Informe</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Col>
            <Row>
              <Col md={12}>
                <FormGroups.FechaFormGroup value={fecha} onChange={e => setFecha(e.target.value)} />
              </Col>
            </Row>
          </Col>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose}>
          Cancelar
        </Button>
        <Button color='secondary' onClick={clickDescargar}>
          Descargar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default DescargarInformeModal
